import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '@/App';

/**
 * useFMKpis - fetches KPI data for a specific gym.
 * Returns { kpis, status, statusReason, gymName, loading, error, refetch }
 */
export function useFMKpis(gymId) {
  const [kpis, setKpis] = useState([]);
  const [status, setStatus] = useState(null);
  const [statusReason, setStatusReason] = useState('');
  const [gymName, setGymName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchKpis = useCallback(async () => {
    if (!gymId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(`/fm/kpi/${gymId}`);
      const data = response.data;

      setKpis(data.kpis || []);
      setStatus(data.status || null);
      setStatusReason(data.status_reason || data.reason || '');
      setGymName(data.gym_name || '');
    } catch (err) {
      console.error('Failed to fetch KPIs:', err);
      setError(err.response?.data?.detail || 'Failed to load KPI data');
    } finally {
      setLoading(false);
    }
  }, [gymId]);

  useEffect(() => {
    fetchKpis();
  }, [fetchKpis]);

  return { kpis, status, statusReason, gymName, loading, error, refetch: fetchKpis };
}
